import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconNightlife = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconNightlife",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M280-240v-160L81-698q-14-20-2-41t36-21h410q24 0 36 21t-2 41L360-400v160h40q17 0 29 12t11 28-11 29-29 11H240q-17 0-28-11t-12-29 12-28 28-12zm-44-360h168l56-80H180zm404 440q-50 0-85-35t-35-85 35-85 85-35q11 0 21 2t19 6v-328q0-17 12-28t28-12h100q25 0 43 18t17 42-17 43-43 17h-60v360q0 50-35 85t-85 35"
  })
}));
IconNightlife.displayName = 'IconNightlife';